import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getLatLongByPincodeRequest,
  getLatLongByPincodeSuccess,
  getLatLongByPincodeError,
  pushMssageToSnackbar,
} from '../slices'
import { getLatLongByPincode } from '../../api'

// Worker Saga: Get Lat Long by Pincode
function* handleGetLatLongByPincode(action) {
  try {
    const response = yield call(getLatLongByPincode, action.payload)
    if (response?.latitude && response?.longitude) {
      yield put(getLatLongByPincodeSuccess(response))
    } else {
      const errMsg = 'Pincode is Serviceable'
      yield put(getLatLongByPincodeError(errMsg))
    }
  } catch (error) {
    const errMsg = error.message || 'Unknown Error Occurred'
    yield put(
      pushMssageToSnackbar({
        message: errMsg,
        type: 'error',
      }),
    )
    yield put(getLatLongByPincodeError(errMsg))
  }
}

// Watcher Saga
function* pincodeSaga() {
  yield takeLatest(getLatLongByPincodeRequest.type, handleGetLatLongByPincode)
}

export default pincodeSaga
